import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';

export const userRatingV8nSchema = object().shape({
  user_id: string().required(),
  username: string().required(),
  rating: number().integer().required(),
  comment: stringOptionalNullable,
  user_agent: stringOptionalNullable,
  created_at: string().required(),
});

export const v8nSchemaOfGetRatingsResponse = paginationV8nSchema.shape({
  array: array().of(userRatingV8nSchema),
});
